// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"3f1f6468","271":"dcef5ebd","453":"2de573ac","664":"49820baa","750":"6404066a","945":"b317b210"}[chunkId] + ".chunk.js";
};